<template>
  <div>
    <div class="content">
      <Molded v-if="!success">
        <Wizard
          :totalSteps="5"
          :formName="[
                    'configuracao.1',
                    'configuracao.2',
                    'configuracao.3',
                    'configuracao.4',
                    'configuracao.5',
                ]"
          :showSteps="false"
        >
          <div slot="1">
            <b-row>
              <b-col sm="1">
                <div class="step side-by-side"><span>1</span></div>
              </b-col>
              <b-col sm="10">
                <div class="title side-by-side">
                  Qual <b>ambiente</b> de emissão será utilizado?
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="10">
                <br />
                <br />
                <small class="title-small">Essa informação nos ajuda a identificar se sua empresa já
                  está habilitada para emissão de notas fiscais.
                  Escolha se a emissão será realizada pelo Ambiente Nacional (padrão do Governo
                  Federal) ou diretamente pela Prefeitura do Município
                </small>
                <br />
                <br />
                <RadioGroup
                  :formName="formName"
                  :required="false"
                  field="group"
                  :options="[
                                    { text: 'Nacional', value: 'Nacional' },
                                    { text: 'Prefeitura', value: 'Prefeitura' },
                                ]"
                  v-model="configuracao.comum.ambiente"
                />
              </b-col>
            </b-row>
            <b-row v-if="configuracao.comum.ambiente == 'Prefeitura'">
              <b-col sm="2">
                <InputText
                  :formName="formName"
                  :required="false"
                  field="Próximo RPS"
                  title="Próximo RPS"
                  v-model="configuracao.comum.proximoRps"
                />
              </b-col>
            </b-row>
          </div>
          <div slot="2">
            <b-row>
              <b-col sm="1">
                <div class="step side-by-side"><span>2</span></div>
              </b-col>
              <b-col sm="10">
                <div class="title side-by-side">
                  Sua empresa já está autorizada para emitir <b>Notas Fiscais?</b>
                </div>
              </b-col>
            </b-row>
            <br />
            <small class="title-small">Essa informação nos ajuda a entender se sua empresa já possui
              cadastro e autorização
              ativa na Prefeitura/SEFAZ para emissão de notas, ou se ainda será necessário realizar a
              habilitação antes de configurar o sistema
            </small>
            <br />
            <br />
            <RadioGroup
              :formName="formName"
              :required="false"
              field="group"
              stacked="true"
              :options="[
                            { text: 'Sim, estamos autorizados', value: 'Sim, estamos autorizados' },
                            { text: 'Não, ainda não estamos autorizados', value: 'Não, ainda não estamos autorizados' },
                            { text: 'Não tenho certeza', value: 'Não tenho certeza' },
                        ]"
              v-model="configuracao.comum.habilitada"
            />

          </div>
          <div slot="3">
            <b-row>
              <b-col sm="1">
                <div class="step side-by-side"><span>3</span></div>
              </b-col>
              <b-col sm="10">
                <div class="title side-by-side">
                  Informe o <b>Regime Tributário</b>
                </div>
              </b-col>
            </b-row>
            <br />
            <div>
              <Molded>
                <b-row>
                  <b-col sm="2">
                    <RadioGroup
                      :formName="formName"
                      :required="false"
                      field="group"
                      title="Simples Nacional"
                      :options="[
                                                { text: 'Sim', value: true },
                                                { text: 'Não', value: false },
                                            ]"
                      v-model="configuracao.prefeitura.optanteSimplesNacional"
                    />
                  </b-col>
                  <b-col sm="4">
                    <SelectStatic
                      :initialValue="configuracao.prefeitura.regimeTributario"
                      title="Regime Tributário"
                      :required="false"
                      :data="optionsRegimeTributario"
                      v-model="configuracao.prefeitura.regimeTributario"
                    />
                  </b-col>
                  <b-col sm="4">
                    <SelectStatic
                      :initialValue="configuracao.prefeitura.regimeTributarioEspecial"
                      title="Regime Tributário Especial"
                      :required="false"
                      :data="optionsRegimeTributarioEspecial"
                      v-model="configuracao.prefeitura.regimeTributarioEspecial"
                    />
                  </b-col>
                  <b-col sm="2">
                    <RadioGroup
                      :formName="formName"
                      :required="false"
                      field="group"
                      title="Incentivador Cultural"
                      :options="[
                                                { text: 'Sim', value: true },
                                                { text: 'Não', value: false },
                                            ]"
                      v-model="configuracao.prefeitura.incentivadorCultural"
                    />
                  </b-col>
                </b-row>
              </Molded>
            </div>
            <br>
            <div v-if="configuracao.comum.ambiente == 'Nacional'">
              <b-row>
                <b-col
                  sm="6"
                  v-if="ehSimplesNacional"
                >
                  <SelectStatic
                    :initialValue="configuracao.nacional.codigoOpcaoSimplesNacional"
                    title="Situação perante Simples Nacional"
                    :required="false"
                    :data="[
                                            { content: 'Não Optante', id: 'Não Optante' },
                                            { content: 'Optante - Microempreendedor Individual (MEI)', id: 'Optante - Microempreendedor Individual (MEI)' },
                                            { content: 'Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)', id: 'Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)' },
                                        ]"
                    v-model="configuracao.nacional.codigoOpcaoSimplesNacional"
                  />
                </b-col>
                <b-col :sm="!ehSimplesNacional ? '12' : '6'">
                  <SelectStatic
                    :initialValue="configuracao.nacional.tipoTributacao"
                    title="Tipo de Tributação ISS"
                    :formName="formName"
                    :required="false"
                    :data="[
                                            { content: 'Tributação no Município', id: 'Tributação no Município' },
                                            { content: 'Tributação fora do Município', id: 'Tributação fora do Município' },
                                            { content: 'Isenção', id: 'Isenção' },
                                            { content: 'Imune', id: 'Imune' },
                                            { content: 'Exigibilidade Suspensa por Decisão Judicial', id: 'Exigibilidade Suspensa por Decisão Judicial' },
                                            { content: 'Exigibilidade Suspensa por Procedimento Administrativo', id: 'Exigibilidade Suspensa por Procedimento Administrativo' },
                                        ]"
                    v-model="configuracao.nacional.tipoTributacao"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  sm="6"
                  v-if="ehSimplesNacional"
                >
                  <SelectStatic
                    :initialValue="configuracao.nacional.regimeApuracaoTributariaSimplesNacional"
                    title="Regime de Apuração Tributária pelo Simples Nacional"
                    :required="false"
                    :data="[
                                            { content: 'Federais e municipal pelo SN', id: 'Federais e municipal pelo SN' },
                                            { content: 'Federais pelo SN e ISSQN pela NFS-e municipal', id: 'Federais pelo SN e ISSQN pela NFS-e municipal' },
                                            { content: 'Federais e municipal pela NFS-e', id: 'Federais e municipal pela NFS-e' },
                                        ]"
                    v-model="configuracao.nacional.regimeApuracaoTributariaSimplesNacional"
                  />
                </b-col>
                <b-col :sm="!ehSimplesNacional ? '12' : '6'">
                  <SelectStatic
                    :initialValue="configuracao.nacional.regimeEspecialTributacaoMunicipal"
                    title="Regime Especial de Tributação Municipal"
                    :required="false"
                    :data="[
                                            { content: 'Nenhum', id: 'Nenhum' },
                                            { content: 'Ato Cooperado', id: 'Ato Cooperado' },
                                            { content: 'Estimativa', id: 'Estimativa' },
                                            { content: 'Microempresa Municipal', id: 'Microempresa Municipal' },
                                            { content: 'Notário ou Registrador', id: 'Notário ou Registrador' },
                                            { content: 'Profissional Autônomo', id: 'Profissional Autônomo' },
                                            { content: 'Sociedade de Profissionais', id: 'Sociedade de Profissionais' },
                                        ]"
                    v-model="configuracao.nacional.regimeEspecialTributacaoMunicipal"
                  />
                </b-col>
              </b-row>

              <b-row v-if="!ehSimplesNacional">
                <b-col sm="12">
                  <SelectStatic
                    :initialValue="configuracao.nacional.situacaoTributariaPisCofins"
                    title=" Situação Tributária do PIS/COFINS"
                    :formName="formName"
                    :required="false"
                    :data="[
                                            { content: 'Operação Tributável com Alíquota Básica', id: 'Operação Tributável com Alíquota Básica' },
                                            { content: 'Operação Tributável com Alíquota Diferenciada', id: 'Operação Tributável com Alíquota Diferenciada' },
                                            { content: 'Operação Tributável com Alíquota por Unidade de Medida de Produto', id: 'Operação Tributável com Alíquota por Unidade de Medida de Produto' },
                                            { content: 'Operação Tributável monofásica - Revenda a Alíquota Zero', id: 'Operação Tributável monofásica - Revenda a Alíquota Zero' },
                                            { content: 'Operação Tributável por Substituição Tributária', id: 'Operação Tributável por Substituição Tributária' },
                                            { content: 'Operação Tributável a Alíquota Zero', id: 'Operação Tributável a Alíquota Zero' },
                                            { content: 'Operação Tributável da Contribuição', id: 'Operação Tributável da Contribuição' },
                                            { content: 'Operação sem Incidência da Contribuição', id: 'Operação sem Incidência da Contribuição' },
                                            { content: 'Operação com Suspensão da Contribuição', id: 'Operação com Suspensão da Contribuição' },
                                        ]"
                    v-model="configuracao.nacional.situacaoTributariaPisCofins"
                  />
                </b-col>
              </b-row>
            </div>
            <div v-if="configuracao.comum.ambiente == 'Prefeitura'">
              <SelectStatic
                :initialValue="configuracao.prefeitura.naturezaOperacao"
                title="Natureza da Operação"
                :formName="formName"
                :required="false"
                :data="[
                                    { content: 'Tributação no Município', id: 'Tributação no Município' },
                                    { content: 'Tributação fora do Município', id: 'Tributação fora do Município' },
                                    { content: 'Isenção', id: 'Isenção' },
                                    { content: 'Imune', id: 'Imune' },
                                    { content: 'Exigibilidade Suspensa por Decisão Judicial', id: 'Exigibilidade Suspensa por Decisão Judicial' },
                                    { content: 'Exigibilidade Suspensa por Procedimento Administrativo', id: 'Exigibilidade Suspensa por Procedimento Administrativo' },
                                ]"
                v-model="configuracao.prefeitura.naturezaOperacao"
              />
            </div>
            <b-row>
              <b-col sm="2">
                <InputNumber
                  title="Alíquota ISS %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.iss"
                />
              </b-col>
              <b-col
                sm="2"
                v-if="!ehSimplesNacional"
              >
                <InputNumber
                  title="Alíquota PIS %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.pis"
                />
              </b-col>
              <b-col
                sm="2"
                v-if="!ehSimplesNacional"
              >
                <InputNumber
                  title="Alíquota COFINS %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.cofins"
                />
              </b-col>
              <b-col
                sm="2"
                v-if="!ehSimplesNacional"
              >
                <InputNumber
                  title="Alíquota CSLL %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.csll"
                />
              </b-col>
              <b-col
                sm="2"
                v-if="!ehSimplesNacional"
              >
                <InputNumber
                  title="Alíquota INSS %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.inss"
                />
              </b-col>
              <b-col
                sm="2"
                v-if="!ehSimplesNacional"
              >
                <InputNumber
                  title="Alíquota IR %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.ir"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="2">
                <InputNumber
                  title="IBS %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.ibs"
                />
              </b-col>
              <b-col sm="2">
                <InputNumber
                  title="CBS %"
                  field="aliquota"
                  type="float"
                  :formName="formName"
                  :required="false"
                  :maxLength="9"
                  v-model="configuracao.comum.cbs"
                />
              </b-col>
            </b-row>
            <div>
              <b-row>
                <b-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="2"
                  xl="2"
                >
                  <InputNumber
                    :required="false"
                    type="float"
                    title="Federais %"
                    field="percentualTotalTributosFederais"
                    :maxLength="9"
                    v-model="configuracao.nacional.percentualTotalTributosFederais"
                  />
                </b-col>
                <b-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="2"
                  xl="2"
                >
                  <InputNumber
                    :required="false"
                    type="float"
                    title="Estaduais %"
                    field="percentualTotalTributosEstaduais"
                    :maxLength="9"
                    v-model="configuracao.nacional.percentualTotalTributosEstaduais"
                  />
                </b-col>
                <b-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="2"
                  xl="2"
                >
                  <InputNumber
                    :required="false"
                    type="float"
                    title="Municipais %"
                    field="percentualTotalTributosMunicipais"
                    :maxLength="9"
                    v-model="configuracao.nacional.percentualTotalTributosMunicipais"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
          <div slot="4">
            <b-row>
              <b-col sm="1">
                <div class="step side-by-side"><span>4</span></div>
              </b-col>
              <b-col sm="10">
                <div class="title side-by-side"><b>Autenticação</b></div>
              </b-col>
            </b-row>
            <br />
            <br />
            <RadioGroup
              v-if="configuracao.comum.ambiente == 'Prefeitura'"
              :formName="formName"
              :required="false"
              field="group"
              :options="[
                                { text: 'Certificado Digital', value: 'Certificado Digital' },
                                { text: 'Login e Senha', value: 'Login e Senha' },
                            ]"
              v-model="configuracao.comum.autenticacao"
            />
            <br />
            <Certificate v-if="configuracao.comum.autenticacao == 'Certificado Digital'" />
            <div v-else>
              <InputText
                :formName="formName"
                field="Login Prefeitura"
                title="Login Prefeitura"
                v-model="configuracao.comum.loginPrefeitura"
              />
              <InputPassword
                :formName="formName"
                field="Senha Prefeitura"
                title="Senha Prefeitura"
                v-model="configuracao.comum.senhaPrefeitura"
              />
            </div>
            <br />
            <br />
          </div>
          <div slot="5">
            <b-row>
              <b-col sm="1">
                <div class="step side-by-side"><span>5</span></div>
              </b-col>
              <b-col sm="10">
                <div class="title side-by-side">
                  Informe os dados do <b>serviço</b>
                </div>
              </b-col>
            </b-row>
            <br />
            <small class="title-small">Após a configuração inicial, você poderá adicionar novos serviços
              sempre que
              precisar</small>
            <br />
            <br />
            <div v-if="configuracao.comum.ambiente == 'Prefeitura'">
              <b-row>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="codigoLC116"
                        title="Código LC 116"
                        v-model="configuracao.prefeitura.servico.codigoLC116"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="Código LC 116"
                        :options="optionsCodigoLC116"
                        buttonTitle="Ver opções"
                        v-model="configuracao.prefeitura.servico.codigoLC116"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="cnae"
                        title="CNAE"
                        v-model="configuracao.prefeitura.servico.cnae"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="CNAE"
                        :options="optionsCnae"
                        buttonTitle="Ver opções"
                        v-model="configuracao.prefeitura.servico.cnae"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="nbs"
                        title="NBS (Nomenclatura Brasileira de Serviços)"
                        v-model="configuracao.prefeitura.servico.nbs"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="NBS (Nomenclatura Brasileira de Serviços)"
                        :options="optionsNbs"
                        buttonTitle="Ver códigos NBS"
                        v-model="configuracao.prefeitura.servico.nbs"
                      />
                    </div>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <InputText
                    :required="false"
                    :formName="formName"
                    field="Aliquota do ISSQN"
                    title="Aliquota do ISSQN"
                    v-model="configuracao.prefeitura.servico.aliquotaISSQN"
                  />
                </b-col>
                <b-col sm="8">
                  <InputText
                    :required="false"
                    :formName="formName"
                    field="Discriminação"
                    title="Discriminação"
                    v-model="configuracao.prefeitura.servico.discriminacao"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="codigoIndicadorOperacao"
                        title="Código Indicador Operação"
                        v-model="configuracao.prefeitura.servico.codigoIndicadorOperacao"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="Código Indicador Operação"
                        :options="optionsCodigoIndicadorOperacao"
                        buttonTitle="Ver opções"
                        v-model="configuracao.prefeitura.servico.codigoIndicadorOperacao"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="ibsCbsSituacaoTributaria"
                        title="IBS/CBS Situação Tributária"
                        v-model="configuracao.prefeitura.servico.ibsCbsSituacaoTributaria"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="IBS/CBS Situação Tributária"
                        :options="optionsTributacaoIBSCBS"
                        buttonTitle="Ver opções"
                        v-model="configuracao.prefeitura.servico.ibsCbsSituacaoTributaria"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="ibsCbsClassificacaoTributaria"
                        title="IBS/CBS Classificação Tributária"
                        v-model="configuracao.prefeitura.servico.ibsCbsClassificacaoTributaria"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="IBS/CBS Classificação Tributária"
                        :options="optionsClassificacaoTributaria"
                        buttonTitle="Ver opções"
                        v-model="configuracao.prefeitura.servico.ibsCbsClassificacaoTributaria"
                      />
                    </div>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <small class="step-by-step-title-small">
                    Para maiores informações sobre os campos de IBS/CBS, consulte a classificação
                    oficial em
                    <a
                      href="https://dfe-portal.svrs.rs.gov.br/DFE/ClassificacaoTributaria"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <b>Classificação Tributária</b>
                    </a>
                    e realize a verificação.
                  </small>
                </b-col>
              </b-row>

            </div>
            <div v-else>
              <b-row>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="codigoTributacaoNacional"
                        title="Código de Tributação Nacional"
                        v-model="configuracao.nacional.servico.codigoTributacaoNacional"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="Código de Tributação Nacional"
                        :options="optionsCodigoTributacaoNacional"
                        buttonTitle="Ver opções"
                        v-model="configuracao.nacional.servico.codigoTributacaoNacional"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col sm="4">
                  <InputText
                    :required="false"
                    :formName="formName"
                    field="codigoTributacaoMunicipal"
                    title="Código de Tributação Municipal"
                    v-model="configuracao.nacional.servico.codigoTributacaoMunicipal"
                  />
                </b-col>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="nbs"
                        title="NBS (Nomenclatura Brasileira de Serviços)"
                        v-model="configuracao.nacional.servico.nbs"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="NBS (Nomenclatura Brasileira de Serviços)"
                        :options="optionsNbs"
                        buttonTitle="Ver códigos NBS"
                        v-model="configuracao.nacional.servico.nbs"
                      />
                    </div>
                  </b-row>
                </b-col>

              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="10">
                      <InputText
                        :required="false"
                        :formName="formName"
                        field="cnae"
                        title="CNAE"
                        v-model="configuracao.nacional.servico.cnae"
                      />
                    </b-col>
                    <div class="step-by-step-opcoes">
                      <OpcoesFiscaisGoverno
                        modalTitle="CNAE"
                        :options="optionsCnae"
                        buttonTitle="Ver opções"
                        v-model="configuracao.nacional.servico.cnae"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col sm="2">
                  <InputText
                    :required="false"
                    :formName="formName"
                    field="Aliquota do ISSQN"
                    title="Aliquota do ISSQN"
                    v-model="configuracao.nacional.servico.aliquotaISSQN"
                  />
                </b-col>
                <b-col sm="6">
                  <InputText
                    :required="false"
                    :formName="formName"
                    field="Discriminação"
                    title="Discriminação"
                    v-model="configuracao.nacional.servico.discriminacao"
                  />
                </b-col>
              </b-row>

            </div>
            <br />
          </div>
          <div slot="finish">
            <div class="text-center">
              <Button
                _key="create"
                classIcon="fa-sharp fa-solid fa-paper-plane-top"
                type="success"
                title="Enviar dados"
                size="medium"
                :disabled="!isFormValid(formName)"
                :clicked="create"
              />
            </div>
          </div>
        </Wizard>
        <br />
      </Molded>
      <div
        class="div-success"
        v-else
      >
        <Molded>
          <br>
          <b-row>
            <b-col
              sm="12"
              class="text-center"
            >
              <div class="company">Seu cadastro foi enviado com sucesso!</div>
              <div>
                Nossa equipe irá validar as informações e retornaremos!
              </div>
              <div class="icon-success">
                <i class="fa-light fa-circle-check"></i>
              </div>
            </b-col>
          </b-row>
          <br>
        </Molded>
      </div>
    </div>
  </div>
</template>

<script>
import Wizard from "@nixweb/nixloc-ui/src/component/layout/Wizard.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import InputPassword from "@nixweb/nixloc-ui/src/component/forms/InputPassword";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import SelectStatic from "@nixweb/nixloc-ui/src/component/forms/SelectStatic";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup";
import Certificate from "../certificate/Certificate.vue";
import OpcoesFiscaisGoverno from "../shared/OpcoesFiscaisGoverno.vue";

import Person from "@nixweb/nixloc-ui/src/component/value-objects/Person.vue";
import Contact from "@nixweb/nixloc-ui/src/component/value-objects/Contact.vue";
import Address from "@nixweb/nixloc-ui/src/component/value-objects/Address.vue";

import Helpers from "../shared/Helpers.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

const STORAGE_KEY = "wizard-configuracao-step-by-step-form";

function isPageReload() {
  try {
    const nav = performance.getEntriesByType("navigation");
    if (nav && nav.length) return nav[0].type === "reload";
    return (
      performance && performance.navigation && performance.navigation.type === 1
    );
  } catch (e) {
    return false;
  }
}

export default {
  name: "Register",
  components: {
    Wizard,
    Molded,
    Button,
    InputText,
    InputPassword,
    InputNumber,
    RadioGroup,
    Contact,
    Person,
    SelectStatic,
    Address,
    Certificate,
    OpcoesFiscaisGoverno,
  },
  data() {
    return {
      formName: "step-by-step-form",
      urlCreate: "/api/v1/tax-document/config-company/step-by-step",
      configuracao: {
        comum: {
          ambiente: "Nacional",
          habilitada: "Sim, estamos autorizados",
          autenticacao: "Certificado Digital",
          loginPrefeitura: "",
          senhaPrefeitura: "",
          proximoRps: "",
          inss: 0,
          pis: 0,
          cofins: 0,
          iss: 0,
          csll: 0,
          ir: 0,
          ibs: 0,
          cbs: 0,
        },
        nacional: {
          codigoOpcaoSimplesNacional: {
            content: "Não Optante",
            id: "Não Optante",
          },
          tipoTributacao: {
            content: "Tributação no Município",
            id: "Tributação no Município",
          },
          regimeEspecialTributacaoMunicipal: {
            content: "Nenhum",
            id: "Nenhum",
          },
          regimeApuracaoTributariaSimplesNacional: {
            content: "Federais e municipal pelo SN",
            id: "Federais e municipal pelo SN",
          },
          situacaoTributariaPisCofins: {
            content: "Operação Tributável com Alíquota Básica",
            id: "Operação Tributável com Alíquota Básica",
          },
          percentualTotalTributosFederais: 0,
          percentualTotalTributosEstaduais: 0,
          percentualTotalTributosMunicipais: 0,
          servico: {
            codigoTributacaoNacional: "",
            codigoTributacaoMunicipal: "",
            cnae: "",
            nbs: "",
            aliquotaISSQN: "",
            discriminacao: "",
          },
        },
        prefeitura: {
          optanteSimplesNacional: true,
          regimeTributario: {
            content: "Simples Nacional",
            id: "Simples Nacional",
          },
          regimeTributarioEspecial: { content: "Nenhum", id: "Nenhum" },
          incentivadorCultural: false,
          naturezaOperacao: {
            content: "Tributação no Município",
            id: "Tributação no Município",
          },
          servico: {
            codigoLC116: "",
            cnae: "",
            nbs: "",
            codigoIndicadorOperacao: "",
            ibsCbsClassificacaoTributaria: "",
            ibsCbsSituacaoTributaria: "",
            aliquotaISSQN: "",
            discriminacao: "",
          },
        },
      },
      success: false,
    };
  },
  created() {
    if (isPageReload()) {
      localStorage.removeItem(STORAGE_KEY);
    }
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        this.configuracao = JSON.parse(saved);
        this.normalizeLegacyFields();
      } catch (e) {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ehSimplesNacional() {
      return this.configuracao.prefeitura.optanteSimplesNacional;
    },
    optionsRegimeTributario() {
      let optionsFinal = [];
      let options = [
        { content: "Simples Nacional", id: "Simples Nacional" },
        {
          content: "Simples Nacional - Excesso de Sublimite de Receita Bruta",
          id: "Simples Nacional - Excesso de Sublimite de Receita Bruta",
        },
        { content: "Regime Normal", id: "Regime Normal" },
        {
          content: "Simples Nacional - Microempreendedor Individual - MEI",
          id: "Simples Nacional - Microempreendedor Individual - MEI",
        },
      ];

      options.forEach((option) => {
        if (
          this.ehSimplesNacional &&
          (option.id === "Simples Nacional" ||
            option.id ===
              "Simples Nacional - Excesso de Sublimite de Receita Bruta" ||
            option.id ===
              "Simples Nacional - Microempreendedor Individual - MEI")
        ) {
          optionsFinal.push(option);
        } else if (!this.ehSimplesNacional && option.id === "Regime Normal") {
          optionsFinal.push(option);
        }
      });

      return optionsFinal;
    },
    optionsRegimeTributarioEspecial() {
      const options = [
        { content: "Nenhum", id: "Nenhum" },
        { content: "Microempresa Municipal", id: "Microempresa Municipal" },
        { content: "Estimativa", id: "Estimativa" },
        {
          content: "Sociedade de Profissionais",
          id: "Sociedade de Profissionais",
        },
        { content: "Cooperativa", id: "Cooperativa" },
        { content: "MEI - Simples Nacional", id: "MEI - Simples Nacional" },
        { content: "ME EPP- Simples Nacional", id: "ME EPP- Simples Nacional" },
      ];

      let optionsFinal = [{ content: "Nenhum", id: "Nenhum" }];

      if (this.ehSimplesNacional) {
        optionsFinal.push(
          options.find((o) => o.id === "MEI - Simples Nacional"),
          options.find((o) => o.id === "ME EPP- Simples Nacional")
        );
      } else {
        optionsFinal.push(
          options.find((o) => o.id === "Microempresa Municipal"),
          options.find((o) => o.id === "Estimativa"),
          options.find((o) => o.id === "Sociedade de Profissionais"),
          options.find((o) => o.id === "Cooperativa")
        );
      }

      return optionsFinal.filter(Boolean);
    },
    optionsCodigoIndicadorOperacao() {
      return Helpers.codigoIndicadorOperacao;
    },
    optionsCodigoTributacaoNacional() {
      return Helpers.codigoTributacaoNacional;
    },
    optionsCodigoLC116() {
      return Helpers.codigoLC116;
    },
    optionsClassificacaoTributaria() {
      const situacaoSelecionada =
        this.configuracao?.prefeitura?.servico?.ibsCbsSituacaoTributaria || "";
      const codigoSituacao = this.getCodigoTributario(situacaoSelecionada);

      if (!codigoSituacao || codigoSituacao === "0") {
        return Helpers.classificacaoTributaria;
      }

      return Helpers.classificacaoTributaria.filter((item) => {
        const codigoClassificacao = this.getCodigoTributario(
          item.id || item.content || ""
        );
        return codigoClassificacao.startsWith(codigoSituacao);
      });
    },
    optionsTributacaoIBSCBS() {
      return Helpers.tributacaoIBSCBS;
    },
    optionsNbs() {
      return Helpers.nbs;
    },
    optionsCnae() {
      return Helpers.cnae;
    },
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["removeLoading", "removeEvent"]),
    ...mapMutations("user", ["addUserLogged"]),
    getCodigoTributario(valor) {
      if (!valor || typeof valor !== "string") {
        return "";
      }

      return valor.split(" - ")[0].trim();
    },
    normalizeLegacyFields() {
      const prefeituraNbs = this.configuracao?.prefeitura?.servico?.nbs;
      if (prefeituraNbs && typeof prefeituraNbs === "object") {
        this.configuracao.prefeitura.servico.nbs =
          prefeituraNbs.id || prefeituraNbs.content || "";
      }

      const prefeituraCodigoIndicadorOperacao =
        this.configuracao?.prefeitura?.servico?.codigoIndicadorOperacao;
      if (
        prefeituraCodigoIndicadorOperacao &&
        typeof prefeituraCodigoIndicadorOperacao === "object"
      ) {
        this.configuracao.prefeitura.servico.codigoIndicadorOperacao =
          prefeituraCodigoIndicadorOperacao.id ||
          prefeituraCodigoIndicadorOperacao.content ||
          "";
      }

      const prefeituraCodigoLC116 =
        this.configuracao?.prefeitura?.servico?.codigoLC116;
      if (prefeituraCodigoLC116 && typeof prefeituraCodigoLC116 === "object") {
        this.configuracao.prefeitura.servico.codigoLC116 =
          prefeituraCodigoLC116.id || prefeituraCodigoLC116.content || "";
      }

      const prefeituraIbsCbsClassificacaoTributaria =
        this.configuracao?.prefeitura?.servico?.ibsCbsClassificacaoTributaria;
      if (
        prefeituraIbsCbsClassificacaoTributaria &&
        typeof prefeituraIbsCbsClassificacaoTributaria === "object"
      ) {
        this.configuracao.prefeitura.servico.ibsCbsClassificacaoTributaria =
          prefeituraIbsCbsClassificacaoTributaria.id ||
          prefeituraIbsCbsClassificacaoTributaria.content ||
          "";
      }

      const prefeituraIbsCbsSituacaoTributaria =
        this.configuracao?.prefeitura?.servico?.ibsCbsSituacaoTributaria;
      if (
        prefeituraIbsCbsSituacaoTributaria &&
        typeof prefeituraIbsCbsSituacaoTributaria === "object"
      ) {
        this.configuracao.prefeitura.servico.ibsCbsSituacaoTributaria =
          prefeituraIbsCbsSituacaoTributaria.id ||
          prefeituraIbsCbsSituacaoTributaria.content ||
          "";
      }

      const nacionalNbs = this.configuracao?.nacional?.servico?.nbs;
      if (nacionalNbs && typeof nacionalNbs === "object") {
        this.configuracao.nacional.servico.nbs =
          nacionalNbs.id || nacionalNbs.content || "";
      }

      const nacionalCodigoTributacaoNacional =
        this.configuracao?.nacional?.servico?.codigoTributacaoNacional;
      if (
        nacionalCodigoTributacaoNacional &&
        typeof nacionalCodigoTributacaoNacional === "object"
      ) {
        this.configuracao.nacional.servico.codigoTributacaoNacional =
          nacionalCodigoTributacaoNacional.id ||
          nacionalCodigoTributacaoNacional.content ||
          "";
      }
    },
    create() {
      let request = {
        ambiente: this.configuracao.comum.ambiente,
        habilitada: this.configuracao.comum.habilitada,
        autenticacao: this.configuracao.comum.autenticacao,
        loginPrefeitura: this.configuracao.comum.loginPrefeitura,
        senhaPrefeitura: this.configuracao.comum.senhaPrefeitura,
        proximoRps: this.configuracao.comum.proximoRps,

        optanteSimplesNacional:
          this.configuracao.prefeitura.optanteSimplesNacional,
        regimeTributario:
          this.configuracao.prefeitura.regimeTributario?.id ?? "",
        regimeTributarioEspecial:
          this.configuracao.prefeitura.regimeTributarioEspecial?.id ?? "",
        incentivadorCultural: this.configuracao.prefeitura.incentivadorCultural,
        naturezaOperacao:
          this.configuracao.prefeitura.naturezaOperacao?.id ?? "",

        codigoOpcaoSimplesNacional:
          this.configuracao.nacional.codigoOpcaoSimplesNacional?.id ?? "",
        tipoTributacao: this.configuracao.nacional.tipoTributacao?.id ?? "",
        regimeEspecialTributacaoMunicipal:
          this.configuracao.nacional.regimeEspecialTributacaoMunicipal?.id ??
          "",
        regimeApuracaoTributariaSimplesNacional:
          this.configuracao.nacional.regimeApuracaoTributariaSimplesNacional
            ?.id ?? "",
        situacaoTributariaPisCofins:
          this.configuracao.nacional.situacaoTributariaPisCofins?.id ?? "",
        percentualTotalTributosFederais:
          this.configuracao.nacional.percentualTotalTributosFederais,
        percentualTotalTributosEstaduais:
          this.configuracao.nacional.percentualTotalTributosEstaduais,
        percentualTotalTributosMunicipais:
          this.configuracao.nacional.percentualTotalTributosMunicipais,

        pis: this.configuracao.comum.pis,
        cofins: this.configuracao.comum.cofins,
        iss: this.configuracao.comum.iss,
        csll: this.configuracao.comum.csll,
        inss: this.configuracao.comum.inss,
        ir: this.configuracao.comum.ir,
        ibs: this.configuracao.comum.ibs,
        cbs: this.configuracao.comum.cbs,

        codigoTributacaoNacional:
          this.configuracao.nacional.servico.codigoTributacaoNacional,
        codigoTributacaoMunicipal:
          this.configuracao.nacional.servico.codigoTributacaoMunicipal,

        codigoLC116: this.configuracao.prefeitura.servico.codigoLC116,
        codigoIndicadorOperacao:
          this.configuracao.prefeitura.servico.codigoIndicadorOperacao,
        ibsCbsClassificacaoTributaria:
          this.configuracao.prefeitura.servico.ibsCbsClassificacaoTributaria,
        ibsCbsSituacaoTributaria:
          this.configuracao.prefeitura.servico.ibsCbsSituacaoTributaria,

        cnae:
          this.configuracao.comum.ambiente === "Prefeitura"
            ? this.configuracao.prefeitura.servico.cnae
            : this.configuracao.nacional.servico.cnae,

        nbs:
          this.configuracao.comum.ambiente === "Prefeitura"
            ? this.configuracao.prefeitura.servico.nbs
            : this.configuracao.nacional.servico.nbs,

        aliquotaISSQN:
          this.configuracao.comum.ambiente === "Prefeitura"
            ? this.configuracao.prefeitura.servico.aliquotaISSQN
            : this.configuracao.nacional.servico.aliquotaISSQN,

        discriminacao:
          this.configuracao.comum.ambiente === "Prefeitura"
            ? this.configuracao.prefeitura.servico.discriminacao
            : this.configuracao.nacional.servico.discriminacao,
      };

      let params = { url: this.urlCreate, obj: request, notNotifyToast: true };
      this.postApi(params).then((response) => {
        if (response.success) {
          localStorage.removeItem(STORAGE_KEY);
          this.success = true;
        }
        this.removeLoading(["create"]);
      });
    },
  },
  watch: {
    "configuracao.prefeitura.optanteSimplesNacional": {
      deep: true,
      handler(val) {
        if (this.ehSimplesNacional) {
          this.configuracao.prefeitura.regimeTributario = {
            content: "Simples Nacional",
            id: "Simples Nacional",
          };
        } else {
          this.configuracao.prefeitura.regimeTributario = {
            content: "Regime Normal",
            id: "Regime Normal",
          };
        }
      },
    },
    "configuracao.prefeitura.servico.ibsCbsSituacaoTributaria": {
      handler(novoValor) {
        const codigoSituacao = this.getCodigoTributario(novoValor);
        if (!codigoSituacao || codigoSituacao === "0") {
          return;
        }

        const classificacaoAtual =
          this.configuracao?.prefeitura?.servico
            ?.ibsCbsClassificacaoTributaria || "";
        const codigoClassificacao =
          this.getCodigoTributario(classificacaoAtual);

        if (
          codigoClassificacao &&
          !codigoClassificacao.startsWith(codigoSituacao)
        ) {
          this.configuracao.prefeitura.servico.ibsCbsClassificacaoTributaria =
            "";
        }
      },
    },
    configuracao: {
      deep: true,
      handler(val) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(val));
      },
    },
  },
};
</script>

<style scoped>
.step {
  margin-top: 5px;
  height: 48px;
  width: 48px;
  font-size: 20px;
  display: grid;
  place-items: center;
  background-color: #fafafc;
  border-radius: 100%;
  border: 1px solid #dbdfe9;
  position: relative;
  color: #8ca1b7;
}

.title {
  margin-top: 9px;
  font-size: 18px;
}

.icon-success {
  font-size: 50px;
  color: #52c41a;
}

.div-success {
  width: 550px;
  margin: auto;
}

.company {
  font-size: 20px;
}

.step-by-step-opcoes {
  margin-top: 20px;
}
</style>
